import { useTranslation } from "react-i18next";

/**
 * The Garagevo logo (docs/arculat): the "eye in the nut" mark and the word,
 * "evo" in evo green. `onDark` turns the nut light for dark backgrounds.
 * The word is the program name from the locale files ("Garagevo").
 */
export function Logo({ onDark = false, word = true, size = 30 }: { onDark?: boolean; word?: boolean; size?: number }) {
  const { t } = useTranslation();
  const name = t("app.title");
  const nut = onDark ? "#F2F5F7" : "#0E2433";
  const eye = onDark ? "#0E2433" : "#F2F5F7";
  return (
    <span className="brand-logo" role="img" aria-label={name}>
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
        <path d="M32 4 L56 18 L56 46 L32 60 L8 46 L8 18 Z" fill={nut} />
        <circle cx="32" cy="32" r="14" fill={eye} />
        <circle cx="32" cy="32" r="7" fill="#10B89A" />
        {size >= 24 && <circle cx="35" cy="29" r="2.2" fill={eye} />}
      </svg>
      {word && (
        <span className="brand-word" aria-hidden="true">
          {name.toLowerCase().endsWith("evo") ? (
            <>
              {name.slice(0, -3).toLowerCase()}
              <span className="evo">{name.slice(-3).toLowerCase()}</span>
            </>
          ) : (
            name
          )}
        </span>
      )}
    </span>
  );
}
